module.exports = __webpack_public_path__ + "static/media/playbackleft.2c4ab453.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/playbackleft.svg
// module id = 1581
// module chunks = 1